import { IConfig } from 'unleash-proxy-client'
import { env } from './env'

// Use the same storage key as the Unleash client.
// This keeps the same session id for users who already have one.
const UNLEASH_SESSION_ID_STORAGE_KEY = 'unleash:repository:sessionId'

const generateSessionId = (): string => {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

// The Unleash client sets sessionId later when it starts.
// Sometimes a request goes out before that happens.
// If that request has no sessionId, the user can get the wrong variant.
// So we create it here first and pass it to the client.
export const getOrCreateUnleashSessionId = (): string => {
  try {
    const stored = localStorage.getItem(UNLEASH_SESSION_ID_STORAGE_KEY)

    if (stored !== null) {
      try {
        const parsed: unknown = JSON.parse(stored)
        // Only accept the two shapes the unleash client has ever stored:
        // a non-empty string or a finite number (0 included).
        if (typeof parsed === 'string' && parsed.length > 0) return parsed
        if (typeof parsed === 'number' && Number.isFinite(parsed)) return String(parsed)
      } catch {
        // Bad value in storage, make a new one below.
      }
    }

    const fresh = generateSessionId()
    localStorage.setItem(UNLEASH_SESSION_ID_STORAGE_KEY, JSON.stringify(fresh))
    return fresh
  } catch {
    // localStorage is not available, use one id for this page load.
    return generateSessionId()
  }
}

const config: IConfig = {
  url: env.REACT_APP_UNLEASH_URL,
  clientKey: env.REACT_APP_UNLEASH_CLIENT_KEY,
  refreshInterval: 30,
  appName: 'web-members',
  environment: env.REACT_APP_ENV,
  metricsInterval: 30,
  bootstrap: [],
  context: { sessionId: getOrCreateUnleashSessionId() }
}

export default config
